"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactSharedUiNext = require("@eon-funke/react-shared-ui-next");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Stepbox = /*#__PURE__*/function (_React$Component) {
  function Stepbox() {
    (0, _classCallCheck2.default)(this, Stepbox);
    return _callSuper(this, Stepbox, arguments);
  }
  (0, _inherits2.default)(Stepbox, _React$Component);
  return (0, _createClass2.default)(Stepbox, [{
    key: "render",
    value: function render() {
      var steps = this.props.steps;
      var grid;
      var offset = '';
      if (steps.length !== 1) {
        grid = 12 / steps.length;
      } else {
        grid = '6';
        offset = 'col-sm-offset-3';
      }
      var baseClass = 'stepbox-wrapper';
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "row stepbox-wrapper"
      }, steps.map(function (el, i) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "col-sm-".concat(grid, " ").concat(offset, " ").concat(baseClass, "__step-container ").concat(!el.active ? "".concat(baseClass, "-inactive") : '', " "),
          key: i
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "step-title"
        }, el.success && /*#__PURE__*/_react.default.createElement("span", null, "\u2714 "), el.name, ' ', i + 1), /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(baseClass, "__step-box")
        }, el.success ? /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Icon, {
          size: "54",
          glyph: "icon_checkbox_54x54"
        }) : el.icon, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h5", null, el.title), /*#__PURE__*/_react.default.createElement("p", null, el.desc), el.button && /*#__PURE__*/_react.default.createElement("div", {
          className: "".concat(baseClass, "__button-wrapper text-center")
        }, /*#__PURE__*/_react.default.createElement(_reactSharedUiNext.Button, {
          version: el.button.version,
          onClick: el.button.onClick
        }, el.button.text)))));
      }));
    }
  }]);
}(_react.default.Component);
Stepbox.propTypes = {
  steps: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    title: _propTypes.default.string,
    desc: _propTypes.default.string,
    active: _propTypes.default.bool.isRequired,
    success: _propTypes.default.bool.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    icon: _propTypes.default.object.isRequired,
    button: _propTypes.default.shape({
      text: _propTypes.default.string,
      version: _propTypes.default.string,
      onClick: _propTypes.default.func
    })
  }))
};
var _default = exports.default = Stepbox;